import React, { Component } from 'react'
import { StaticBox, FlowTable, Modal } from 'components/basic'
import { date, notify } from 'helpers'
import { Installation } from 'config'
import ReactHtmlParser from 'react-html-parser'
import http from 'API/http'

class Tickets extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tickets: null,
      ticketModal: false,
      accessId: ''
    }
  }
  componentDidMount () {
    this.getTickets(this.props.accessId)
  }
  componentWillReceiveProps(props) {
    if (props.accessId === this.props.accessId) return
    this.getTickets(props.accessId)
  }
  async getTickets (accessId) {
    var err, res
    [err, res] = await http.get('2.3/accesses/' + accessId + '/tickets')
    if (err) return notify.alert('', err.message, 'error')
    this.setState({tickets: res.data, accessId: accessId})
  }
  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }
  render () {
    if (!this.state.tickets) return false
    if (!Installation.enable.tickets) return false
    return (
      <div>
        <StaticBox cols={12} icon='ticket' title='Tickets' buttons={[
          {icon: 'fa-plus', event: e => (window.location = '/#/ticket/wizard/' + this.state.accessId), hidden: !Installation.enable.ticketsCreate},
          {icon: 'fa-plus', event: e => this.setState({ticketModal: Installation.ticketRules}), hidden: Installation.enable.ticketsCreate}
        ]}>
          <FlowTable paginatable={10} data={this.state.tickets.map(ticket => [
            <a href={'/#/ticket/' + ticket.ticketRef} className='table-link'><i className='fa fa-folder-open-o' /></a>,
            ReactHtmlParser(ticket.title),
            ticket.ticketRef,
            this.getStatus(ticket.state.status)
          ])}>
            <tr>
              <th className='buttons' />
              <th>Title</th>
              <th>ID</th>
              <th>Status</th>
            </tr>
          </FlowTable>
        </StaticBox>
        <Modal title='Ticket Information' isOpen={this.state.ticketModal} close={e => this.setState({ticketModal: false})}>
          {ReactHtmlParser(Installation.ticketRules)}
        </Modal>
      </div>
    )
  }
}
export default Tickets



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/2.4/access/Tickets.js